import React, { useState, useEffect, useRef } from 'react';
import { Button, Card, CardBody, Input, FormGroup, Label, Row, Col } from 'reactstrap';
import useAxios from 'hooks/useAxios';
import { toast } from 'react-toastify';
import { Formik, Field } from 'formik';
import { cloneDeep } from 'lodash';
import commonColumns, { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';
import cellEditRender from 'components/reactStrapTable/components/CellEditRender';
import Confirm from 'components/Confirm';
import save from "assets/icon/save.svg";

let checkedIds = [];
const SmartApproval = ({ mappedData, tenantID, toggle }) => {
    const API = useAxios();
    const [loading, setLoading] = useState(false);
    const [patientData, setPatientData] = useState({});
    const [statusList, setStatusList] = useState([]);
    const [pdata, setData] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [claimStatusID, setClaimID] = useState('');
    const [isConfirm, setConfirm] = useState(false);
    const [comments, setComments] = useState("");
    const [claimCount, setClaimCount] = useState(0);
    const [profitLoss, setProfitLoss] = useState(0);
    const formikRef = useRef();

    useEffect(() => {
        checkedIds = [];
        fetchMappedPatientInfo();
        fetchSmartApprovalStatus();
        fetchSmartApprovalClaims();
    }, []);


    const fetchMappedPatientInfo = async () => {
        try {
            setLoading(true);
            let result = await API.post(`/${tenantID}/Fax/mappedpatientinfo/${mappedData.CoveredEntityID}`, mappedData, {
                hideLoader: true,
            });

            if (result) {
                setPatientData(result.data);
            }
        }
        catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    const fetchSmartApprovalStatus = async () => {
        try {
            const { data } = await API.get(
                `/${tenantID}/fax/claimstatus/${mappedData.CoveredEntityID}`,
                {
                    hideLoader: true,
                }
            );
            setLoading(false);
            setStatusList(data);
        } catch (error) {
            setLoading(false);
        }
    };



    const fetchSmartApprovalClaims = async () => {
        try {
            const { data } = await API.post(
                `/${tenantID}/Claim/SmartApprovalPatientClaims/${parseInt(mappedData.patientId)}`,
                mappedData
            );
            if (data) {
                setData(data);
                setClaimCount(data.length);
                let plAmount = 0;
                for (var x in data) {
                    var rw = data[x];
                    plAmount += rw.profitLoss;
                }
                setProfitLoss(plAmount);
            }
        } catch (error) { }
    };


    let copyCommonColumns = cloneDeep(commonColumns);




    const columns = [
        {
            dataField: 'attachement',
            text: 'Options',
            cellRenderer: (rowData) => attachFile(rowData),
            width: 120,
            show: true,
            disabled: true,
            hideColFilter: true,
            action: true,
        },
        ...copyCommonColumns,
    ];

    const attachFile = (claim) => {
        const { canFax, suppressFlag, isFaxSent, isFaxReceived } = claim;
        const filter = selectedIds.filter((item) => item === claim.claimID);
        return (
            <div className='d-flex align-items-center'>
                {renderCheckbox(claim)}
            </div>
        );
    };

    const renderCheckbox = (claim) => {
        const filter = selectedIds.filter((item) => item === claim.claimID);
        return (
            <Input
                onChange={() => onChange(claim)}
                type='checkbox'
                className='me-2 mt-0'
                value={filter.length > 0}
                checked={filter.length > 0}
            />);
    }

    const onChange = (claim) => {
        const { claimID, rxNumber, providerID } = claim;
        const index = checkedIds.indexOf(claimID);
        if (checkedIds.length === 0) {
            checkedIds.push(claimID);
        } else {
            if (index >= 0) {
                checkedIds.splice(index, 1);
            } else {
                checkedIds.push(claimID);
            }
        }
        setSelectedIds([...checkedIds]);
    };

    const handlerChange = (event) => {
        const { value } = event.target;
        if (value)
            setClaimID(value);
        else
            setClaimID('');
    };

    const onChangeHandler = (event) => {
        const { value } = event.target;
        setComments(value);
    }


    let disabled = (claimStatusID && checkedIds.length > 0) ? false : true;

    const handleSaveConfirmation = () => {
        setConfirm(!isConfirm);

    };

    const handleSubmit = async (val, action) => {
        handleSaveConfirmation();
        setLoading(true);
        try {

            let payload = {};
            payload.CoveredEntityID = mappedData.CoveredEntityID;
            payload.ClaimStatusID = claimStatusID;
            payload.Comments = comments;
            payload.ClaimIDs = checkedIds;

            const { data } = await API.post(
                `/${tenantID}/Claim/savesmartapproval/${parseInt(mappedData.CoveredEntityID)}`,
                payload
            );
            if (data) {
                toast.success('Claims updated successfully');
                toggle(false);
            }
        } catch (error) {

        }
    }

    return (
        <div>
            <Formik
                onSubmit={handleSubmit}
            >
                <div>
                    <Row>
                        <Col>
                            <p className='f-14 mb-0'>
                                Patient First Name -
                                <b className='d-block font-weight-500'>{patientData.patientFirstName}</b>
                            </p>
                        </Col>
                        <Col>
                            <p className='f-14 mb-0'>
                                Patient Last Name -
                                <b className='d-block font-weight-500'>{patientData.patientLastName}</b>
                            </p>
                        </Col>
                        <Col>
                            <p className='f-14 mb-0'>
                                DOB - <b className='d-block font-weight-500'> {dateFormate(patientData.patientDOB)}</b>
                            </p>
                        </Col>
                        <Col>
                            <p className='f-14 mb-0'>
                                MRN - <b className='d-block font-weight-500'> {patientData.medicalRecordNumber}</b>
                            </p>
                        </Col>
                    </Row>
                    <Row className='mt-2'>
                        <Col>
                            <p className='f-14 mb-0'>
                                Provider Name - <b className='d-block font-weight-500'> {patientData.providerFirstName} {patientData.providerLastName} </b>
                            </p>
                        </Col>
                        <Col>
                            <p className='f-14 mb-0'>
                                Provider NPI - <b className='d-block font-weight-500'> {patientData.providerNPI} </b>
                            </p>
                        </Col>
                    </Row>
                    <Row className='mt-2'>
                        <Col md={4}>
                            <FormGroup>
                                Claim Status - <Input
                                    type='select'
                                    onChange={(e) => handlerChange(e)}
                                    bsSize='sm'
                                    className={`d-inline-block}`}
                                >
                                    <option value={''}>--Select--</option>
                                    {statusList.map((status) => {
                                        const { id, description } = status;
                                        return (
                                            <option key={id} value={id}>
                                                {description}
                                            </option>
                                        );
                                    })}
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            Reason - <input
                                className="form-control"
                                type="text"
                                onChange={(e) => onChangeHandler(e)} />
                        </Col>
                        <Col md={2} className='pt-4 mt-0'>
                            <Label> &nbsp;</Label>
                            <Button
                                color='primary'
                                className='ms-3 search'
                                disabled={disabled}
                                onClick={handleSaveConfirmation}
                            >
                                <span className="right_5">
                                    <img src={save} alt="" />
                                </span>{" "} Submit
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={2}>
                            <FormGroup>
                                Claim Count - {claimCount}
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            Profit/Loss - {currencyFormat(profitLoss)}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <div
                                    className='table-card filter-table position-relative border-0'
                                    style={{ height: "400px", "overflow-y": "scroll" }}
                                >
                                    <ReactStrapTable
                                        id='patient-details-table'
                                        fixedColumn
                                        height={50 * 5}
                                        width={1200}
                                        columns={columns}
                                        data={pdata}
                                        loader
                                    />
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>
                </div>

            </Formik>

            <Confirm
                isOpen={isConfirm}
                loading={loading}
                message='Are you sure you want to save?'
                onToggle={handleSaveConfirmation}
                onCancel={handleSaveConfirmation}
                onContinue={handleSubmit}
            />

        </div>
    );

};

export default SmartApproval;